/**
 * fadeSlider
 */
import fadeSlider from './component'


export default {
  install(Vue, options) {

    // const state = {
    //   current: 0
    // }

    // Vue.util.defineReactive(Vue.prototype, '$fadeSlider', state)
    Vue.component('fade-slider', fadeSlider)
  }
}


// WEBPACK FOOTER //
// ./src/plugins/fadeSlider/index.js